<!--
 * @Description:
 * @Date: 2019-04-10 09:48:28
 -->
<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div style="display:flex;flex-direction:column;align-items:baseline">
        <el-button
          type="success"
          @click="add"
          class="addBtn"
          icon="el-icon-plus"
        >
          新建专区
        </el-button>
        <br />
        <div>
          <span>关联状态:</span>
          <el-select v-model="searchQuery.status" style="margin-right:20px;">
            <el-option
              v-for="item in linkStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>专区名称:</span>
          <el-input
            class="search-input"
            v-model="searchQuery.title"
            placeholder="请输入关键字"
            clearable
            style="margin-right:20px;"
          ></el-input>
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="title"
          label="专区名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="更新时间"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status > 0"
              type="text"
              size="small"
              @click="checkStatus(scope.row)"
            >
              已关联
            </el-button>
            <div v-else>未关联</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.projectStatus <= 0"
              type="text"
              size="small"
              @click="showLinkCom(scope.row)"
              style="color:#DE750A;"
            >
              生成链接
            </el-button>
            <el-button
              :disabled="scope.row.projectStatus <= 0"
              type="text"
              size="small"
              @click="goDistDetail(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              :disabled="scope.row.status > 0"
              type="text"
              size="small"
              @click="del(scope)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[15, 60, 100]"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <prod-link v-if="showLink" :url="linkUrl"></prod-link>
  </div>
</template>
<script>
//   import datePicker from "@/Mixin/datePicker";
import { channel } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import Config from '@/config/index';
import linkDetail from './components/linkDetail.vue';
import prodLink from './components/prodLink.vue';
import createExtend from '@/components/createExtend';

export default {
  mixins: [pageInation],
  data() {
    return {
      childSearchQuery: {},
      linkUrl: '',
      showDetail: false,
      showLink: false,
      getList: channel.channelList, // 获取列表的AJAX
      searchQuery: {
        title: '',
        status: ''
      },
      linkStatus: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 1,
          label: '已关联'
        },
        {
          value: 2,
          label: '未关联'
        }
      ]
    };
  },
  components: {
    prodLink
  },
  computed: {},
  methods: {
    showLinkCom(row) {
      this.linkUrl = `http:${Config.webViewUrl}/html/index.html#/zoneHome?zone_id=${row.id}&fromcode=web&platform=web`;
      this.showLink = true;
    },
    checkStatus(row) {
      createExtend(linkDetail, {
        searchQuery: { id: row.id }
      });
    },
    add() {
      this.$router.push({
        path: '/zone/detail'
      });
    },
    del(scope) {
      //删除
      let delEvent = scope => {
        let { row } = scope;
        channel
          .deleteChannel({
            id: row.id
          })
          .then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.$makeSure(delEvent, scope, '是否确认删除');
    },
    goDistDetail(row) {
      this.$router.push({
        path: '/zone/detail',
        query: {
          id: row.id
        }
      });
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
  padding: 25px 15px;
}
</style>
